import { Pipeline } from "@telespot/domain";
import { ParseMapper } from "../../parse.mapper";
import { ObjectTopology } from "../../parse.topology";

export enum PipelineTopology {
  TABLE = "Pipeline",
  NAME = "name",
  DESCRIPTION = "description",
  ENV = "env",
}

export class ParsePipelineMapper extends ParseMapper {
  public toDomain(parseObject: Parse.Object): Pipeline {
    return new Pipeline({
      id: parseObject.id,
      name: parseObject.get(PipelineTopology.NAME),
      description: parseObject.get(PipelineTopology.DESCRIPTION),
      env: parseObject.get(PipelineTopology.ENV),
      createdAt: parseObject.get(ObjectTopology.CREATED_AT),
    });
  }

  public fromDomain(pipeline: Pipeline) {
    const ParsePipeline = this.subclasses.getSubclass(PipelineTopology.TABLE);

    const parseObject = pipeline.id
      ? ParsePipeline.createWithoutData(pipeline.id)
      : new ParsePipeline();

    parseObject.set(PipelineTopology.NAME, pipeline.name);
    parseObject.set(PipelineTopology.DESCRIPTION, pipeline.description);
    parseObject.set(PipelineTopology.ENV, pipeline.env);

    return parseObject;
  }
}
